var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSteddy = function SvgSteddy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 32 26",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.8067 25.9746c-13.26701 0-14.8067-5.6732-14.8067-8.9805v-.3816h8.26303c.10265 1.5519 1.0008 3.9942 7.51887 3.9942h.4875c6.6721 0 7.4162-1.3229 7.4162-2.6713 0-1.4501-.7955-2.3659-6.6463-2.544l-4.3625-.1018c-9.44344-.2289-12.343199-3.409-12.343199-7.32678v-.30529c0-3.73972 2.258219-7.65753 13.780299-7.65753h2.3608c11.984 0 14.7041 4.14677 14.7041 7.93738v.33072h-8.2373c-.1797-.94129-.6929-3.00196-7.3136-3.00196h-.5389c-6.13311 0-6.56935 1.0685-6.56935 2.16243 0 1.06849.69286 2.06067 5.85085 2.16243l4.2598.07632c9.5205.17808 13.3697 2.46768 13.3697 7.45398v.4834c0 4.1468-2.1042 8.3953-14.8324 8.3953h-2.3609z",
    fill: "#788779"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSteddy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "steddy.b4bf22c9d23178b747f2e75d46c31e23.svg";